<template>
    <div class="page">
        <div class="content">
            <div class="title">
                <div>
                    <span>产品中心</span>
                </div>
            </div>
            <div class="main-wrap">
                <!-- 左侧树形导航 -->
                <div class="sidebar">
                    <div class="tree-node" v-for="(primary, pIdx) in type" :key="pIdx">
                        <div class="tree-primary" :class="{ 'tree-active': tabIndex === primary.value }"
                            @click="handleTreePrimary(primary)">
                            {{ primary.label }}
                        </div>
                        <!-- 二级分类（切换一级时加载） -->
                        <div class="tree-children" v-if="tabIndex === primary.value && twoTypeList.length > 0">
                            <div class="tree-child" :class="{ 'child-active': twoTypeIndex === null }"
                                @click="handleTreeChild(null)">
                                全部
                            </div>
                            <div class="tree-child" v-for="(child, cIdx) in twoTypeList" :key="cIdx"
                                :class="{ 'child-active': twoTypeIndex === child.value }"
                                @click="handleTreeChild(child)">
                                {{ child.label }}
                            </div>
                        </div>
                        <!-- 三级分类预留位（后续扩展 threeType 时启用） -->
                        <!--
                        <div class="tree-grandchildren" v-if="tabIndex === primary.value && threeTypeList.length > 0">
                            <div class="tree-grandchild" v-for="(gc, gIdx) in threeTypeList" :key="gIdx"
                                 :class="{ 'gc-active': threeTypeIndex === gc.value }"
                                 @click="handleTreeGrandchild(gc)">
                                {{ gc.label }}
                            </div>
                        </div>
                        -->
                    </div>
                </div>
                <!-- 右侧产品列表 -->
                <div class="product-area">
                    <div class="genre_box">
                        <div class="introduce_box" v-for="(item, index) in productList" :key="index"
                            @click="goDetails(item)">
                            <div class="introduce_main">
                                <div class="introduce_img">
                                    <img :src="imgUrl + item.small" alt="">
                                </div>
                                <div class="introduce_text">
                                    <div class="product_name">{{ item.name }}</div>
                                    <div class="model_text" v-if="item.productModel">{{ item.productModel }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { postApiConfig } from "@/api/apiConfig.js";
    export default {
        name: "box_1",
        data() {
            return {
                productList: '',
                productListAll: '',      // 完整列表（二级分类筛选前）
                activeName: 'hardware',
                type: [
                    { label: '硬件产品', value: 1, name: 'hardware' },
                    { label: '服务产品', value: 2, name: 'service' },
                ],
                tabIndex: 1,
                twoTypeList: [],          // 二级分类 tab 列表
                twoTypeIndex: null,       // 当前选中的二级分类 value（null=全部）
                twoTypeLabelMap: {        // twoType 值 → 显示名称
                    1: '考试类',
                    2: '实验类',
                    3: '其他',
                },
                // 查询参数
                queryParams: {
                    current: 1,
                    size: 999,
                },
                bannerHeight: '',
            }
        },
        mounted() {
            this.queryParams.type = 1
            this.getList();
        },
        methods: {

            goDetails(item) {
                // console.log(item)
                // this.$router.push("/productDetails");
                this.$router.push({
                    path: `/productDetails`,
                    query: { res: item.id },
                });
            },
            getList() {
                postApiConfig("/pc/page/product", this.queryParams).then((res) => {
                    this.productListAll = res.data.records
                    // 从数据中提取唯一的 twoType 值，兼容数字(1)和中文标签("考试类")两种格式
                    const values = [...new Set(this.productListAll.map(item => item.twoType).filter(v => v != null))]
                    this.twoTypeList = values.map(v => ({
                        value: v,
                        label: typeof v === 'number' ? (this.twoTypeLabelMap[v] || `分类${v}`) : v
                    }))
                    this.filterByTwoType()
                });
            },
            // 切换一级分类（树形导航）
            handleTreePrimary(data) {
                this.handleClick(data)
            },
            // 切换二级分类（树形导航）
            handleTreeChild(item) {
                this.handleSubClick(item)
            },
            // 切换一级分类
            handleClick(data) {
                this.productList = '';
                this.productListAll = '';
                this.tabIndex = data.value
                this.twoTypeIndex = null   // 重置二级分类
                this.twoTypeList = []
                this.queryParams.type = data.value
                this.getList()
            },
            // 切换二级分类
            handleSubClick(item) {
                this.twoTypeIndex = item === null ? null : item.value
                this.filterByTwoType()
            },
            // 按二级分类筛选
            filterByTwoType() {
                if (this.twoTypeIndex === null) {
                    this.productList = this.productListAll
                } else {
                    this.productList = this.productListAll.filter(item => item.twoType == this.twoTypeIndex)
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/style/tabs.css";

    .page {
        width: 100%;
        background-color: #f6f7fb;

        .content {
            width: 1200px;
            padding: 100px 0;
            margin: auto;
            box-sizing: border-box;

            .title {
                width: 100%;
                color: #040030;
                text-align: center;

                div {
                    &:nth-child(1) {
                        color: #333333;
                        font-size: 44px;
                    }
                }
            }

            .text_con {
                width: 100%;
            }

            // 左右分栏
            .main-wrap {
                margin-top: 30px;
                display: flex;
                align-items: flex-start;
                gap: 30px;
            }

            // 左侧树形导航
            .sidebar {
                width: 220px;
                flex-shrink: 0;
                background-color: #ffffff;
                border-radius: 6px;
                padding: 10px 0;
                box-sizing: border-box;

                .tree-node {
                    .tree-primary {
                        display: flex;
                        align-items: center;
                        padding: 14px 24px;
                        font-size: 17px;
                        font-weight: 500;
                        color: #333;
                        cursor: pointer;
                        transition: all 0.2s;
                        border-left: 3px solid transparent;
                        position: relative;
                    }

                    .tree-active {
                        color: #2478ff;
                        background-color: rgba(36, 120, 255, 0.06);
                        border-left-color: #2478ff;
                        font-weight: 600;

                        .tree-primary-icon {
                            color: #2478ff;
                        }
                    }

                    // 二级分类
                    .tree-children {
                        padding: 0 0 6px 0;

                        .tree-child {
                            padding: 8px 24px 8px 52px;
                            font-size: 14px;
                            color: #666;
                            cursor: pointer;
                            transition: all 0.2s;
                            position: relative;

                            &:hover {
                                color: #2478ff;
                                background-color: rgba(36, 120, 255, 0.04);
                            }

                            &::before {
                                content: '';
                                position: absolute;
                                left: 34px;
                                top: 0;
                                bottom: 0;
                                width: 1px;
                                background-color: #e8e8e8;
                            }

                            &::after {
                                content: '';
                                position: absolute;
                                left: 34px;
                                top: 50%;
                                width: 10px;
                                height: 1px;
                                background-color: #e8e8e8;
                            }
                        }

                        .child-active {
                            color: #2478ff;
                            font-weight: 500;
                            background-color: rgba(36, 120, 255, 0.06);
                        }
                    }

                    // 三级分类预留（后续扩展 threeType 时启用）
                    /* .tree-grandchildren { ... } */
                    /* .tree-grandchild { ... } */
                }
            }

            // 右侧产品区域
            .product-area {
                flex: 1;
                min-width: 0;

                .genre_box {
                    width: 100%;
                    min-width: 0;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 20px 20px;

                    .introduce_box {
                        min-width: 0;
                        box-sizing: border-box;

                        .introduce_main {
                            background-color: #ffffff;
                            border-radius: 12px;
                            overflow: hidden;
                            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
                            box-sizing: border-box;
                            transition: all 0.4s ease;

                            &:hover {
                                transform: translateY(-6px);
                                box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
                            }
                        }

                        .introduce_img {
                            width: 100%;
                            height: 252px;
                            overflow: hidden;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-bottom: 2px dashed #f6f7fb;

                            img {
                                width: auto;
                                height: 70%;
                                max-width: 100%;
                                object-fit: contain;
                            }
                        }

                        .new_introduce_img {
                            width: 100%;
                            height: 352px;
                            overflow: hidden;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .introduce_text {
                            padding: 8px 20px;
                            min-height: 74px;
                            box-sizing: border-box;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            gap: 6px;

                            .product_name {
                                color: #040030;
                                font-size: 18px;
                                font-weight: 500;
                                text-align: center;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                max-width: 100%;
                            }

                            .model_text {
                                color: #040030;
                                font-size: 18px;
                                font-weight: 500;
                                text-align: center;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                max-width: 100%;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
